// extracted by mini-css-extract-plugin
export var container = "SummaryBlock-module--container--e6e19";
export var containerSmall = "SummaryBlock-module--containerSmall--68a0e";
export var link = "SummaryBlock-module--link--1c4df";
export var linkCheckmark = "SummaryBlock-module--linkCheckmark--551b0";
export var linkContainer = "SummaryBlock-module--linkContainer--d3d29";
export var linkSimple = "SummaryBlock-module--linkSimple--ee7dc";
export var linksContainer = "SummaryBlock-module--linksContainer--cdf23";
export var seeMoreButton = "SummaryBlock-module--seeMoreButton--635b2";
export var title = "SummaryBlock-module--title--62ff2";
export var titleSmall = "SummaryBlock-module--titleSmall--72014";